import React from 'react';
import { Button, Card, Table, TableColumnsType, Tag } from 'antd';
import { formatDateTime, getDocumentLabels, textNumberFormater } from '../../../../utils';

interface BillDetailNotesCardProps {
  notes: any[];
  onNavigateNote: (uid: string) => void;
}

export const BillDetailNotesCard: React.FC<BillDetailNotesCardProps> = ({
  notes,
  onNavigateNote
}) => {
  const columnsNotes: TableColumnsType = [
    { title: "Número", dataIndex: "document_number", key: "document_number" },
    { title: "Fecha", dataIndex: "created_at", key: "created_at", render: (text) => formatDateTime(text) },
    { title: "Tipo", dataIndex: "document_type", key: "document_type", render: (text) => {
      const noteLabels = getDocumentLabels(undefined, text);
      return (
        <Tag color={text === 'CREDIT_NOTE' ? 'orange' : 'blue'}>
          {noteLabels.title}
        </Tag>
      );
    }},
    { title: "Motivo", dataIndex: "reason", key: "reason", align: "left" },
    { title: "Total", dataIndex: "total_amount_net", key: "total_amount_net", align: "right", render: (text) => textNumberFormater(text) },
    { title: "Acción", key: "action", align: "center", render: (_, record: any) => (
      <Button type="link" onClick={() => onNavigateNote(record.uid)}>Ver Detalle</Button>
    )}
  ];

  return (
    <Card title="Notas de Crédito / Débito relacionadas" style={{ marginTop: 24 }} className="card-shadow">
      <Table 
        columns={columnsNotes} 
        dataSource={notes} 
        pagination={false} 
        size="small"
        rowKey={(record: any, index?: number) => String(record.key || record.uid || record.id || record.document_number || `note-${index}`)}
        locale={{ emptyText: 'No hay notas relacionadas para esta factura' }}
        scroll={{ x: 600 }}
      />
    </Card>
  );
};
